export const loginText = `
    <a href="{loginLink}">Zaloguj się,</a> żeby zobaczyć swoje notatki i zakreślenia.
`;
